import {styled} from '@linaria/react';
import React, {PropsWithChildren, forwardRef} from 'react';
import {AriaButtonLinkType} from '../../../types/AriaButtonLink';
import {AnimatedDots} from '../Loaders/AnimatedDots';
import {Button, ButtonProps} from './Button';

export const LoadingButton = forwardRef<
  HTMLButtonElement,
  PropsWithChildren<
    ButtonProps &
      AriaButtonLinkType & {isLoading?: boolean; style?: React.CSSProperties}
  >
>(function LoadingButton(
  {isLoading, children, 'aria-label': ariaLabel, ...rest},
  ref,
) {
  return (
    <StyledButton ref={ref} {...rest} aria-label={ariaLabel}>
      <span style={{visibility: isLoading ? 'hidden' : 'visible'}}>
        {children}
      </span>
      {isLoading && <StyledAnimatedDots />}
    </StyledButton>
  );
});

const StyledButton = styled(Button)`
  position: relative;
`;

const StyledAnimatedDots = styled(AnimatedDots)`
  position: absolute;
  inset: 0;
  top: 50%;
  transform: translateY(-50%);
`;
